/*
 * Field configuration objects incl. default value to display if empty
 */
const field = {
  dyn: { value: '', format: 'string', type: 'date', unit: '' },
  date: { value: '', format: 'date', type: 'date', unit: '' },
  str: {
    value: '-',
    format: 'string',
    type: 'text',
    unit: '',
    //desc: 'enter a brief info',
  },
  txt: {
    value: '-',
    format: 'string',
    type: 'textarea',
    unit: '',
    //desc: 'type a short description',
    exp: 'max_chars',
    maxLength: 1200,
  },
  sel: { value: '-', format: 'string', type: 'select', unit: '' },
  bool: {
    value: '-',
    format: 'boolean',
    type: 'checkbox',
    unit: '',
    //desc: 'available: yes/no →',
    exp: 'available',
  },
  int: {
    value: '-',
    format: 'int',
    type: 'number',
    unit: '',
    //desc: 'i.e. 4',
  },
  float: {
    value: '-',
    format: 'float',
    type: 'number',
    unit: '',
    //desc: 'i.e. 4 or 3.5',
  },
  mbps: {
    value: '-',
    format: 'float',
    type: 'number',
    unit: 'mbps',
    //desc: 'i.e. 4 or 3.5',
    exp: 50,
  },
  m: {
    value: '-',
    format: 'float',
    type: 'number',
    unit: 'm',
    //desc: 'meters i.e. 14 or 12.5',
  },
  pax: {
    value: '-',
    format: 'int',
    type: 'number',
    unit: 'pax',
    //desc: 'number of people',
  },
  sqm: {
    value: '-',
    format: 'float',
    type: 'number',
    unit: 'sqm',
    //desc: 'square meters i.e. 42 or 64.5',
  },
  km: {
    value: '-',
    format: 'float',
    type: 'number',
    unit: 'km',
    //desc: 'kilometers i.e. 4 or 12.5',
    exp: 5,
  },
  per: {
    value: '-',
    format: 'float',
    type: 'number',
    unit: '%',
    //desc: 'percentage from 0 to 100',
    exp: 10,
  },
  email: { value: '', format: 'string', type: 'email', unit: '' },
  pw: { value: '', format: 'float', type: 'password', unit: '' },
  phone: { value: '', format: 'string', type: 'tel', unit: '' },
  url: {
    value: '',
    format: 'string',
    type: 'url',
    unit: '',
    //desc: 'an url https://www.',
    exp: 'url',
  },
  file: {
    value: {
      name: '-',
      description: '',
      type: '',
      icon: 'document',
      url: '',
    },
    format: 'file',
    type: 'file',
    unit: '',
  },
  files: { value: [], format: 'string', type: 'uploads', unit: '' },
  num: {
    value: 0,
    format: 'float',
    type: 'number',
    unit: '',
    //desc: 'i.e. 12 or 14.5',
  },
  volt: {
    value: '-',
    format: 'int',
    type: 'number',
    unit: 'volt',
    //desc: 'i.e. 220 or 500',
  },
  weight: {
    value: '-',
    format: 'float',
    type: 'number',
    unit: 'ksqm',
    //desc: '',
  },
  heavy: {
    value: '-',
    format: 'float',
    type: 'number',
    unit: 'tsqm',
    //desc: '',
  },
  strArr: { value: [], format: 'string', type: 'group', unit: '' },
};

/*
 * All fields
 */
export const fields = {
  // Common Meta
  __typename: field.str,
  id: field.str,
  slug: field.str,
  type: field.sel,
  password: field.pw,
  // Common Item
  plan: field.dyn, // BASIc / GOLD / PLATINUM
  status: field.dyn,
  rating: field.num, // Data ? Auto merge in frontend based on all reviews?
  rateCnt: field.num, // Data ?
  name: field.str,
  family_name: field.str,
  company: field.str,
  headline: field.dyn, // Data ?
  description: field.txt,
  message: field.txt,
  lat: field.num, // Data ?
  lng: field.num, // Data ?
  address: field.dyn, // Data ?
  street: field.dyn, // Data ?
  housenumber: field.dyn, // Data ?
  postcode: field.dyn, // Data ?
  city: field.dyn, // Data ?
  state: field.dyn, // Data ?
  district: field.dyn, // Data ?
  country: field.dyn, // Data ?
  email: field.email,
  phone: field.phone,
  website: field.url,
  facebook: field.url,
  instagram: field.url,
  linkedin: field.url,
  twitter: field.url,
  youtube: field.url,
  pinterest: field.url,
  memberships: field.strArr,
  image: field.file,
  // images: field.files,   //"/assets/thumbs/carousel_0002_venues_shenzhen.jpg"
  // Properties
  barrier_free_access: field.bool,
  broadcasting_studio: field.bool,
  car_parking: { ...field.int, exp: 'total_number' },
  caterer_choice: field.bool,
  conference_largest_room_m2: { ...field.sqm, exp: 2500 },
  conference_largest_room_pax: { ...field.pax, exp: 2000 },
  conference_rooms: field.bool,
  conference_rooms_count: { ...field.int, exp: 15 },
  conference_total_m2: field.sqm,
  conference_total_pax: { ...field.pax, exp: 10000 },
  discount_construction_perc: field.per, // Why String? {value: "-", type: "float", unit: "%"},
  discount_offseason_perc: field.per, // Why String? {value: "-", type: "float", unit: "%"},
  distance_city_centre: field.km,
  events: field.url,
  exhibition_indoor_m2: { ...field.sqm, exp: 85000 },
  exhibition_outdoor_m2: { ...field.sqm, exp: 85000 },
  free_wifi: field.bool,
  hall_max_m2: { ...field.sqm, exp: 6000 },
  hall_min_m2: { ...field.sqm, exp: 3000 },
  halls_count: { ...field.int, exp: 4 },
  health_measures: { ...field.str, exp: 'link_description' },
  inhouse_catering: field.bool,
  iso_certification: { ...field.str, exp: 'link_description' },
  largest_event: field.str,
  map: field.url,
  onsite_restaurants: { ...field.int, exp: 3 },
  onsite_restaurants_pax: { ...field.pax, exp: 10000 },
  promotion: field.txt,
  standard_rate_m2: { ...field.str, exp: 'per_m2' }, // Price ?
  sustainability_policy: { ...field.str, exp: 'link_description' },
  theme_policy: field.bool,
  truck_parking: { ...field.int, exp: 'total_number' },
  zero_carbon: field.bool,
  map_url: field.url,
  // Spaces
  air_conditioning: field.bool,
  area: { ...field.sqm, exp: 10000 },
  av_system: field.bool,
  capacity_max: { ...field.sqm, exp: 10000 },
  capacity_pax: { ...field.pax, exp: 10000 }, // Data: ?
  capacity_per_type: { ...field.str, value: '-/-/-/-/-/-' }, // merged  pax_type_[a-f]
  columns: { ...field.int, exp: 4 },
  electric_capacity: { ...field.volt, exp: 500 },
  electricity: field.bool,
  f_b_outlet: field.str,
  fixed_seating: field.bool,
  flooring_material: { ...field.str, exp: 'exp_flooring' },
  floorplan: field.file,
  floors: { ...field.int, exp: 2 },
  gates: { ...field.int, exp: 4 },
  gates_height: { ...field.m, exp: 3 },
  gates_w_h: field.dyn, // merged gates_width, gates_height
  gates_width: { ...field.m, exp: 3 },
  height: { ...field.m, exp: 15 },
  installation_grid: field.bool,
  installation_grid_m2: { ...field.str, exp: 'exp_grid_size' },
  internet_lan: field.bool,
  internet_speed: field.mbps,
  internet_wifi: field.bool,
  l_w_h: field.dyn, // merged length, width, height
  length: { ...field.m, exp: 50 },
  level: { ...field.int, exp: 4 },
  //light_dimming_adjustment: field.bool, // Obsolete
  load_factor_kg_m2: { ...field.str, exp: 'exp_load_factor' }, // change to int ?
  loading_elevators: field.bool,
  loading_ramps: field.bool,
  natural_light: field.bool,
  natural_light_blocking: field.bool,
  partition_max_rooms: { ...field.int, exp: 'max_partition' },
  partition_walls: field.bool,
  pax_type_1: { ...field.pax, exp: 300 }, // frontal
  pax_type_2: { ...field.pax, exp: 300 }, // frontal table
  pax_type_3: { ...field.pax, exp: 300 }, // long table
  pax_type_4: { ...field.pax, exp: 300 }, // horseshoe
  pax_type_5: { ...field.pax, exp: 300 }, // groups
  pax_type_6: { ...field.pax, exp: 300 }, // party
  podium: field.bool,
  pressurised_air: field.bool,
  removable_seating: field.bool,
  rigging_capcity: { ...field.str, exp: 'exp_rigging_cap' }, // typo in api field rigging_capAcity (A missing)
  rigging_grid: field.bool,
  screen_projector: field.bool,
  // seating_type: field.sqm, // Data: ?
  translator_booth: field.bool,
  water: field.bool, // Data: ?
  width: { ...field.m, exp: 50 },
  // Request Proposal
  event_name: field.str,
  event_date: field.str,
  event_space: {
    ...field.sqm,
    exp: 10000,
    desc: 'required_exhibition_space_info',
  },
  event_pax: { ...field.pax, exp: 10000 },
  event_start: field.date,
  event_end: field.date,
  event_description: field.txt,
  createdAt: field.str,
  // Review Contact
  review: field.str,
  event: field.str,
  contact_type: field.str, //EXHIBITOR, VISITOR or ORGANISER
  contact_name: field.str,
  contact_email: field.str,
  contact_phone: field.str,
  contact_company: field.str,
  // Review
  appeal: field.int,
  cleanliness: field.int,
  facilities: field.int,
  hall: field.int,
  health_efforts: field.int,
  // health_measures: field.int,  // in Venue
  logistics_ease: field.int,
  onsite_catering: field.int,
  onsite_services: field.int,
  professionality: field.int,
  recommend: field.int,
  restrooms: field.int,
  satisfaction_destination: field.int,
  satisfaction_venue: field.int,
  security: field.int,
  staff: field.int,
  sustainability: field.int,
  technical: field.int,
  technology: field.int,
  upkeep: field.int,
  value_money: field.int,
  wayfinding: field.int,
  service_quality: field.int,
  timeliness: field.int,
  // Service Providers
  // Categories
  construction: field.bool,
  design: field.bool,
  installation: field.bool,
  ifes: field.bool,
  // electricity: field.bool, // dupl
  lighting: field.bool,
  flooring: field.bool,
  furniture: field.bool,
  rigging: field.bool,
  catering: field.bool,
  printing: field.bool,
  photo_video: field.bool,
  registration: field.bool,
  logistics: field.bool,
  audio_visual: field.bool,
  staffing: field.bool,
  cleaning: field.bool,
  travel: field.bool,
  deco: field.bool,
  other: field.dyn,
  // Media
  media: field.dyn, // video / document / image
} as any;
